/**
 * Identifiers of the manageable e-mail templates.
 * These string values are the kebab-case keys exposed by the backend
 * (`de.adesso.htx.shared.email.domain.EmailTemplateKey#getKey()`, serialized via `@JsonValue`).
 */
export type EmailTemplateKey =
  | 'registration-approved'
  | 'registration-rejected'
  | 'usecase-participation-approved'
  | 'usecase-participation-rejected'
  | 'representative-change-submitted'
  | 'representative-change-approved-new'
  | 'representative-change-rejected'
  | 'organization-deleted'
  | 'organization-reactivated'
  | 'organization-suspended';

/** All template keys in display order; mirrors the backend enum. */
export const EMAIL_TEMPLATE_KEYS: EmailTemplateKey[] = [
  'registration-approved',
  'registration-rejected',
  'usecase-participation-approved',
  'usecase-participation-rejected',
  'representative-change-submitted',
  'representative-change-approved-new',
  'representative-change-rejected',
  'organization-deleted',
  'organization-reactivated',
  'organization-suspended'
];

/** Row item for the overview table. */
export interface EmailTemplateListItem {
  /** Optional row identifier required by the htx-table generic constraint. */
  id?: string;
  key: EmailTemplateKey;
  subject: string;
  /** Backend compatibility field when the API exposes the rendered subject under a different name. */
  effectiveSubject?: string;
  /** Whether the template has been overridden (true) or matches the default (false). */
  overridden: boolean;
}

/** Full template detail for the edit page. */
export interface EmailTemplateDetail {
  key: EmailTemplateKey;
  subject: string;
  /** Backend compatibility field when the API exposes the rendered subject under a different name. */
  effectiveSubject?: string;
  defaultSubject: string;
  bodyHtml: string;
  /** Backend compatibility field when the API exposes the rendered body under a different name. */
  effectiveBodyHtml?: string;
  defaultBodyHtml: string;
  overridden: boolean;
}

/** Payload for updating a template. */
export interface EmailTemplateUpdateDto {
  subject?: string;
  bodyHtml?: string;
}

/** Rendered preview returned by the backend. */
export interface EmailTemplatePreviewResult {
  subject: string;
  /** Backend compatibility field when the rendered subject is exposed under a different name. */
  effectiveSubject?: string;
  bodyHtml: string;
  /** Backend compatibility field when the rendered body is exposed under a different name. */
  effectiveBodyHtml?: string;
}
